import PropTypes from "prop-types"
import { Text } from "components/Text"
import { Separator } from "components/Separator"
import { Card, CardMedia, CardContent, CardActionArea } from "components/Card"
import { useTranslator } from "components/Translator"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { AlbumFigures } from "domains/album/AlbumFigures"
import { AlbumActions } from "domains/album/AlbumActions"
import { useLikes } from "components/LikesProvider"
import { LikeIcon } from "components/LikeIcon"
import { Image } from "components/Image"

export function AlbumCard(props) {
  const translator = useTranslator()
  const connectedUser = useConnectedUser()

  const { album, ownerId, onDelete } = props
  const { title, nbMedias, updatedAt } = album

  return (
    <Card>
      <CardActionArea
        href={{
          route: "app_account_album_show",
          params: { mediaAlbumId: album.id, userId: ownerId },
        }}
      >
        <AlbumCardHeader album={album} />
        <CardContent className="space-y-2">
          <Text variant="headline4" className="text-dark">
            {title}
          </Text>
          <Text variant="caption">
            {new Date(updatedAt).toLocaleString(translator.locale)}
            {" • "}
            {translator.trans(
              "AlbumCard.nbMedias",
              { nbMedias: nbMedias },
              "components",
            )}
          </Text>
        </CardContent>
        <Separator />
        <CardContent>
          <AlbumFigures album={album} />
        </CardContent>
      </CardActionArea>
      {connectedUser?.id === ownerId ? (
        <CardContent>
          <div className="flex flex-col space-y-2">
            <AlbumActions album={album} onDelete={onDelete} />
          </div>
        </CardContent>
      ) : null}
    </Card>
  )
}

AlbumCard.propTypes = {
  album: PropTypes.shape({
    cover: PropTypes.shape({
      imageFile: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    }),
    nbVisits: PropTypes.number.isRequired,
    nbLikes: PropTypes.number.isRequired,
    nbMedias: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }).isRequired,
  ownerId: PropTypes.number.isRequired,
}

const AlbumCardHeader = ({ album }) => {
  const translator = useTranslator()

  return (
    <CardMedia
      media={
        album.cover ? (
          <Image
            imageFile={album.cover.imageFile}
            size="w640"
            alt=""
            className="object-cover"
          />
        ) : (
          <div className="bg-grey-lighter flex justify-center items-center">
            {translator.trans(
              "AlbumCard.noCoverPlaceholder",
              null,
              "components",
            )}
          </div>
        )
      }
      className="h-60"
    >
      <div className="text-white">
        <LikeButton id={album.id} />
      </div>
    </CardMedia>
  )
}

const LikeButton = ({ id }) => {
  const likes = useLikes()

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    likes.toggleLike(id)
  }

  return (
    <button type="button" onClick={handleClick}>
      <LikeIcon id={id} className="w-6" />
    </button>
  )
}
